<template>
  <Alert v-if="alertContent" :loadingMood="false"  :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=null"/>
  <div id="home">
    <HomeSectionOne :homeLoadingMood="homeLoadingMood" :explain="infos.s_one_explain"/>
    <HomeSectionTwo/>
    <!--axios ok-->
    <HomeSliderOne/>
    <!--axios ok-->
    <HomeSectionTree :homeLoadingMood="homeLoadingMood" :file="infos.s_tree_file"  :explain="infos.s_tree_explain"/>
    <HomeSectionFour/>
    <!--axios-->
    <HomeSectionFive :homeLoadingMood="homeLoadingMood" :explain="infos.s_five_explain"/>
    <!--axios ok-->
    <HomeSectionSix  :homeLoadingMood="homeLoadingMood" :explain="infos.s_six_explain"  />
  </div>
</template>

<script>
  import HomeSectionOne from '../components/HomeSectionOne'
  import HomeSectionTwo from '../components/HomeSectionTwo'
  import HomeSectionTree from '../components/HomeSectionTree'
  import HomeSectionFour from '../components/HomeSectionFour'
  import HomeSectionFive from '../components/HomeSectionFive'
  import HomeSectionSix from '../components/HomeSectionSix'
  import HomeSliderOne from '../components/HomeSliderOne'
  import Alert from '../components/Alert'
  import axios from 'axios'

export default    {
  name: "Home",
  data(){
    return {
      alertContent: null,
      homeLoadingMood: false,
      infos:
              {
                s_one_explain : null,
                s_tree_file:null,
                s_tree_explain:null,
                s_five_explain:null,
                s_six_explain:null

              },
      loginStatus: localStorage.getItem('loginStatus'),
    }
  },
  components: {
    HomeSectionOne,
    HomeSectionTwo,
    HomeSliderOne,
    HomeSectionTree,
    HomeSectionFour,
    HomeSectionFive,
    HomeSectionSix,
    Alert
  },
  methods:{
    async getPageInfos() {
      try {
        this.homeLoadingMood = true;
        let response = await axios.get('api/getPageInfos/mainPage',
                {
                  headers:
                          {
                            "Authorization": `Bearer ${localStorage.getItem('token')}`,
                          }
                });
        this.homeLoadingMood = false;
        this.infos = response.data.results;

      } catch (error) {
        console.log(error)
      }
    },
  },
  mounted() {
    this.getPageInfos();
  },
}
</script>
<style>
  /*.btn-control{*/
    /*visibility: hidden!important;*/
    /*z-index: 5000!important;*/
    /*cursor: pointer!important;*/
  /*}*/
  /***/
  /* smaller, dark, rounded square */
  .flickity-button {
    background: white;
  }
  .flickity-button:hover {
    /*background: #F90;*/
    /*color: white;*/
  }
  .flickity-button:hover .flickity-button-icon {
    /*color: white;*/
  }
  .flickity-prev-next-button {
    width: 40px;
    height: 40px;
    border-radius:50%;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.12);
  }
  /* icon color */
  .flickity-button-icon {
    color: #fe7063;
  }
  /* position outside */
  .flickity-prev-next-button.previous {
    left: 15px;
  }
  .flickity-prev-next-button.next {
    right: 15px;
  }


  /* position dots in carousel */
  .flickity-page-dots {
    margin-bottom: -20px;
  }
  /* white circles */
  .flickity-page-dots .dot {
    width: 10px;
    height: 10px;
    margin: 4px 0 4px 10px;
    opacity: 1;
    background: gray!important;
    background-color: gray!important;
  }
  /* fill-in selected dot */
  .flickity-page-dots .dot.is-selected {
    background: #fe7063!important;
  }
  button , a{
    transition: all 0.1s ease;
  }



  /***/
</style>
